module.exports = __webpack_public_path__ + "img/SprainedWrist-01.da8d1b3b.svg";